export function phone(phn, country) {
    if (phn) {
        switch (country) {
            case "US":
                return ("(" +
                    phn.substring(0, 3) +
                    ") " +
                    phn.substring(3, 6) +
                    "-" +
                    phn.substring(6));
            case "UK":
                return ((phn.substring(0, 1) == "+" ? "" : "+") +
                    phn.substring(0, 2) +
                    "" +
                    phn.substring(2, 6) +
                    "" +
                    phn.substring(6));
            case "CZ":
                return ((phn.substring(0, 1) == "+" ? "" : "+") +
                    phn.substring(0, 3) +
                    "" +
                    phn.substring(3, 6) +
                    "" +
                    phn.substring(6, 9) +
                    "" +
                    phn.substring(9, 15));
            default:
                return country;
        }
    }
}
